import { Switch } from 'antd';
import { SwitchProps } from 'antd/lib/switch';

/** 启用禁用值 */
export enum EnumEnableValue {
  /** 启用 */
  Enable = 1,
  /** 禁用 */
  Disable = 0,
}

const EnableSwitch: React.FC<
  Omit<SwitchProps, 'onChange'> & {
    value?: EnumEnableValue | null;
    onChange?: (value: EnumEnableValue) => void;
  }
> = ({ value, onChange, ...restProps }) => {
  return (
    <Switch
      {...restProps}
      checked={value === EnumEnableValue.Enable}
      onChange={checked =>
        onChange &&
        onChange(checked ? EnumEnableValue.Enable : EnumEnableValue.Disable)
      }
    />
  );
};
export default EnableSwitch;
